import { gql } from "@apollo/client";

export const ALL_SETUP_LISTS_QUERY = gql`
  query ALL_SETUP_LISTS_QUERY($oriId: ID!) {
    setupLists(oriId: $oriId) {
      addressAlertTypes {
        id
        name
        alertLevel
        position
        oriId
      }
      logCodes {
        id
        name
        position
        oriId
      }
      licenseTypes {
        id
        name
        position
        oriId
      }
      incidentFlags {
        id
        name
        position
        oriId
      }
      callPriorities {
        id
        name
        position
        oriId
      }
      incidentPriorities {
        id
        name
        position
        oriId
      }
      commonCallTypes {
        id
        name
        position
        oriId
      }
      classifications {
        id
        name
        position
        oriId
        commonCallType {
          id
          name
          position
          oriId
        }
      }
      incidentOrigins {
        id
        name
        position
        oriId
      }
      areas {
        id
        name
        position
        oriId
      }
      teams {
        id
        name
        position
        oriId
      }
      drugTypes {
        id
        name
        position
        oriId
        drugClassification {
          id
          name
          position
        }
      }
      drugClassifications {
        id
        name
        position
        oriId
      }
      incidentInvolvements {
        id
        name
        position
        oriId
      }
      victimTypes {
        id
        name
        position
        oriId
      }
      genders {
        id
        name
        position
        oriId
      }
      nibrsGenders {
        id
        name
        position
        oriId
      }
      races {
        id
        name
        position
        oriId
      }
      buildTypes {
        id
        name
        position
        oriId
      }
      hairColors {
        id
        name
        position
        oriId
      }
      eyeColors {
        id
        name
        position
        oriId
      }
      facialHairTypes {
        id
        name
        position
        oriId
      }
      hairLengths {
        id
        name
        position
        oriId
      }
      states {
        id
        name
        position
        oriId
      }
      gangAffiliateds {
        id
        name
        position
        oriId
      }
      groups {
        id
        oriId
        name
        position
      }
      ibrArresteeRaceTypes {
        id
        name
        position
        oriId
      }
      docStatuses {
        id
        name
        position
        oriId
      }
      weaponTypes {
        id
        name
        position
        oriId
      }
      injuryTypes {
        id
        name
        position
        oriId
      }
      paperworks {
        id
        name
        position
        oriId
      }
      residentTypes {
        id
        name
        position
        oriId
      }
      statementTypes {
        id
        name
        position
        oriId
      }
      vehicleRoles {
        id
        name
        position
        oriId
      }
      states {
        id
        name
        position
        oriId
      }
      plateTypes {
        id
        name
        position
        oriId
      }
      vehicleColors {
        id
        name
        position
        oriId
      }
      reasonSeizeds {
        id
        name
        position
        oriId
      }
      wreckers {
        id
        name
        position
        oriId
      }
      towingDestinations {
        id
        name
        position
        oriId
      }
      incidentNarrativeTypes {
        id
        name
        position
        oriId
      }
      searchTypes {
        id
        name
        position
        oriId
      }
      attachmentTypes {
        id
        name
        position
        oriId
      }
      vehicleVins {
        id
        name
        position
        oriId
      }
      vehiclePlates {
        id
        name
        position
        oriId
      }
      nibrsViolationTypes {
        id
        name
        position
        oriId
      }
      committedTypes {
        id
        name
        position
        oriId
      }
      locationTypes {
        id
        name
        position
        oriId
      }
      criminalActivityTypes {
        id
        name
        position
        oriId
      }
      assaultTypes {
        id
        name
        position
        oriId
      }
      offenseIbrDesignations {
        id
        name
        position
        oriId
      }
      egressTypes {
        id
        name
        position
        oriId
      }
      forceNoForceTypes {
        id
        name
        position
        oriId
      }
      campusCodes {
        id
        name
        position
        oriId
      }
      justifiableHomicideTypes {
        id
        name
        position
        oriId
      }
      significantEventTypes {
        id
        name
        position
        oriId
      }
      biasTypes {
        id
        name
        position
        oriId
      }
      ibrSuspectVictimRelationshipTypes {
        id
        name
        position
        oriId
      }
      victimLeoStates {
        id
        name
        position
        oriId
      }
      victimLeoAssignments {
        id
        name
        position
        oriId
      }
      ibrMultipleArrestTypes {
        id
        name
        position
        oriId
      }
      arresteeWeaponTypes {
        id
        name
        position
        oriId
      }
      ibrArrestTypes {
        id
        name
        position
        oriId
      }
      ibrClearanceCodes {
        id
        name
        position
        oriId
      }
      ibrJuvenileDispositions {
        id
        name
        position
        oriId
      }
      ticketCategories {
        id
        name
        position
        oriId
      }
      ticketSubCategories {
        id
        name
        position
        oriId
      }
      highways {
        id
        name
        position
        oriId
      }
      municipalities {
        id
        name
        position
        oriId
      }
      ticketDeliveryTypes {
        id
        name
        position
        oriId
      }
      ticketStatuses {
        id
        name
        position
        oriId
      }
      federalViolationCodes {
        id
        name
        position
        oriId
      }
      reliefActTypes {
        id
        name
        position
        oriId
      }
      deliveredToTypes {
        id
        name
        position
        oriId
      }
      perceivedRaces {
        id
        name
        position
        oriId
      }
      ticketStopTypes {
        id
        name
        position
        oriId
      }
      ticketSearchTypes {
        id
        name
        position
        oriId
      }
      ticketEvidenceTypes {
        id
        name
        position
        oriId
      }
      ticketOutcomeTypes {
        id
        name
        position
        oriId
      }
      passengerTicketSearchTypes {
        id
        name
        position
        oriId
      }
      passengerTicketEvidenceTypes {
        id
        name
        position
        oriId
      }
      passengerTicketOutcomeTypes {
        id
        name
        position
        oriId
      }
      weatherConditions {
        id
        name
        position
        oriId
      }
      roadConditions {
        id
        name
        position
        oriId
      }
      trafficConditions {
        id
        name
        position
        oriId
      }
      lightingConditions {
        id
        name
        position
        oriId
      }
      propertyCodes {
        id
        name
        position
        oriId
      }
      unitMeasureTypes {
        id
        name
        position
        oriId
      }
      ibrPropertyDescriptions {
        id
        name
        position
        oriId
      }
      ibrSuspectedDrugTypes {
        id
        name
        position
        oriId
      }
      colorTypes {
        id
        name
        position
        oriId
      }
      propertyActions {
        id
        name
        position
        oriId
      }
      tempEvidenceLocationTypes {
        id
        name
        position
        oriId
      }
      analysisPerformedBies {
        id
        name
        position
        oriId
      }
      analysisRequestTypes {
        id
        name
        position
        oriId
      }
      evidenceLocations {
        id
        location
        subLocation
      }
      uofInstanceTypes {
        id
        name
        position
        oriId
      }
      uofInstances {
        id
        name
        position
        oriId
      }
      uofInjuryDetails {
        id
        name
        position
        oriId
      }
      reviewStatuses {
        id
        name
        position
        oriId
      }
      approvalStatuses {
        id
        name
        position
        oriId
      }
      incidentDispositionTypes {
        id
        name
        position
        oriId
      }
      stateWideEvents {
        id
        name
        position
        oriId
      }
      relationshipTypes {
        id
        name
        position
        oriId
      }
      specialVictimsUnits {
        id
        name
        position
        oriId
      }
      specialVictimsUnits {
        id
        name
        position
        oriId
      }
      specialVictimsUnits {
        id
        name
        position
        oriId
      }
      enforcementActivities {
        id
        name
        position
        oriId
      }
      roadTypes {
        id
        name
        position
        oriId
      }
      weightMethods {
        id
        name
        position
        oriId
      }
      commodities {
        id
        name
        position
        oriId
      }
      axleGroupTypes {
        id
        name
        position
        oriId
        weightLimit
      }
      stateHighways {
        id
        name
        position
        oriId
        roadType {
          id
          name
          oriId
        }
      }
    }
  }
`;

export const SPECIFIC_SETUP_LISTS_QUERY = gql`
  query SPECIFIC_SETUP_LISTS_QUERY($oriId: ID!) {
    setupLists(oriId: $oriId) {
      incidentPriorities {
        id
        name
        position
        oriId
      }
      classifications {
        id
        name
        position
        oriId
        commonCallType {
          id
          name
          position
          oriId
        }
      }
      incidentFlags {
        id
        name
        position
        oriId
      }
      incidentOrigins {
        id
        name
        position
        oriId
      }
      areas {
        id
        name
        position
        oriId
      }
      teams {
        id
        name
        position
        oriId
      }
      incidentInvolvements {
        id
        name
        position
        oriId
      }
      incidentDispositionTypes {
        id
        name
        position
        oriId
      }
      paperworks {
        id
        name
        position
        oriId
      }
      vehicleRoles {
        id
        name
        position
        oriId
      }
      reasonSeizeds {
        id
        name
        position
        oriId
      }
      wreckers {
        id
        name
        position
        oriId
      }
      towingDestinations {
        id
        name
        position
        oriId
      }
      vehicleVins {
        id
        name
        position
        oriId
      }
      vehiclePlates {
        id
        name
        position
        oriId
      }
      incidentNarrativeTypes {
        id
        name
        position
        oriId
      }
      egressTypes {
        id
        name
        position
        oriId
      }
      significantEventTypes {
        id
        name
        position
        oriId
      }
      ticketStatuses {
        id
        name
        position
        oriId
      }
      propertyActions {
        id
        name
        position
        oriId
      }
      tempEvidenceLocationTypes {
        id
        name
        position
        oriId
      }
      analysisPerformedBies {
        id
        name
        position
        oriId
      }
      analysisRequestTypes {
        id
        name
        position
        oriId
      }
      evidenceLocations {
        id
        location
        subLocation
      }
    }
  }
`;

export const COMMON_SETUP_LISTS_QUERY = gql`
  query COMMON_SETUP_LISTS_QUERY($oriId: ID!) {
    setupLists(oriId: $oriId) {
      callPriorities {
        id
        name
        position
        oriId
      }
      weightLimits {
        id
        name
        position
        oriId
      }
      violationOccurrences {
        id
        name
        position
        oriId
      }
      licenseTypes {
        id
        name
        position
        oriId
      }
      addressAlertTypes {
        id
        name
        alertLevel
        position
        oriId
      }
      personAlertTypes {
        id
        name
        alertLevel
        position
        oriId
      }
      vehicleAlertTypes {
        id
        name
        alertLevel
        position
        oriId
      }
      logCodes {
        id
        name
        position
        oriId
      }
      commonCallTypes {
        id
        name
        position
        oriId
      }
      drugTypes {
        id
        name
        position
        oriId
        drugClassification {
          id
          name
          position
        }
      }
      drugClassifications {
        id
        name
        position
        oriId
      }
      victimTypes {
        id
        name
        position
        oriId
      }
      genders {
        id
        name
        position
        oriId
      }
      nibrsGenders {
        id
        name
        position
        oriId
      }
      races {
        id
        name
        position
        oriId
      }
      buildTypes {
        id
        name
        position
        oriId
      }
      hairColors {
        id
        name
        position
        oriId
      }
      eyeColors {
        id
        name
        position
        oriId
      }
      facialHairTypes {
        id
        name
        position
        oriId
      }
      hairLengths {
        id
        name
        position
        oriId
      }
      states {
        id
        name
        position
        oriId
      }
      gangAffiliateds {
        id
        name
        position
        oriId
      }
      groups {
        id
        oriId
        name
        position
      }
      ibrArresteeRaceTypes {
        id
        name
        position
        oriId
      }
      docStatuses {
        id
        name
        position
        oriId
      }
      weaponTypes {
        id
        name
        position
        oriId
      }
      injuryTypes {
        id
        name
        position
        oriId
      }
      residentTypes {
        id
        name
        position
        oriId
      }
      statementTypes {
        id
        name
        position
        oriId
      }
      states {
        id
        name
        position
        oriId
      }
      plateTypes {
        id
        name
        position
        oriId
      }
      vehicleColors {
        id
        name
        position
        oriId
      }
      searchTypes {
        id
        name
        position
        oriId
      }
      attachmentTypes {
        id
        name
        position
        oriId
      }
      nibrsViolationTypes {
        id
        name
        position
        oriId
      }
      committedTypes {
        id
        name
        position
        oriId
      }
      locationTypes {
        id
        name
        position
        oriId
      }
      criminalActivityTypes {
        id
        name
        position
        oriId
      }
      assaultTypes {
        id
        name
        position
        oriId
      }
      offenseIbrDesignations {
        id
        name
        position
        oriId
      }
      forceNoForceTypes {
        id
        name
        position
        oriId
      }
      campusCodes {
        id
        name
        position
        oriId
      }
      justifiableHomicideTypes {
        id
        name
        position
        oriId
      }
      biasTypes {
        id
        name
        position
        oriId
      }
      ibrSuspectVictimRelationshipTypes {
        id
        name
        position
        oriId
      }
      victimLeoStates {
        id
        name
        position
        oriId
      }
      victimLeoAssignments {
        id
        name
        position
        oriId
      }
      ibrMultipleArrestTypes {
        id
        name
        position
        oriId
      }
      arresteeWeaponTypes {
        id
        name
        position
        oriId
      }
      ibrArrestTypes {
        id
        name
        position
        oriId
      }
      ibrClearanceCodes {
        id
        name
        position
        oriId
      }
      ibrJuvenileDispositions {
        id
        name
        position
        oriId
      }
      highways {
        id
        name
        position
        oriId
      }
      municipalities {
        id
        name
        position
        oriId
      }
      ticketDeliveryTypes {
        id
        name
        position
        oriId
      }
      federalViolationCodes {
        id
        name
        position
        oriId
      }
      reliefActTypes {
        id
        name
        position
        oriId
      }
      deliveredToTypes {
        id
        name
        position
        oriId
      }
      perceivedRaces {
        id
        name
        position
        oriId
      }
      ticketStopTypes {
        id
        name
        position
        oriId
      }
      ticketSearchTypes {
        id
        name
        position
        oriId
      }
      ticketEvidenceTypes {
        id
        name
        position
        oriId
      }
      ticketOutcomeTypes {
        id
        name
        position
        oriId
      }
      passengerTicketSearchTypes {
        id
        name
        position
        oriId
      }
      passengerTicketEvidenceTypes {
        id
        name
        position
        oriId
      }
      passengerTicketOutcomeTypes {
        id
        name
        position
        oriId
      }
      weatherConditions {
        id
        name
        position
        oriId
      }
      roadConditions {
        id
        name
        position
        oriId
      }
      trafficConditions {
        id
        name
        position
        oriId
      }
      lightingConditions {
        id
        name
        position
        oriId
      }
      propertyCodes {
        id
        name
        position
        oriId
      }
      unitMeasureTypes {
        id
        name
        position
        oriId
      }
      ibrPropertyDescriptions {
        id
        name
        position
        oriId
      }
      ibrSuspectedDrugTypes {
        id
        name
        position
        oriId
      }
      colorTypes {
        id
        name
        position
        oriId
      }
      uofInstanceTypes {
        id
        name
        position
        oriId
      }
      uofInstances {
        id
        name
        position
        oriId
      }
      uofInjuryDetails {
        id
        name
        position
        oriId
      }
      reviewStatuses {
        id
        name
        position
        oriId
      }
      approvalStatuses {
        id
        name
        position
        oriId
      }
      incidentDispositionTypes {
        id
        name
        position
        oriId
      }
      stateWideEvents {
        id
        name
        position
        oriId
      }
      relationshipTypes {
        id
        name
        position
        oriId
      }
      helpContexts {
        id
        name
        helpUrl
        position
      }
      specialVictimsUnits {
        id
        name
        position
        oriId
      }
      enforcementActivities {
        id
        name
        position
        oriId
      }
      roadTypes {
        id
        name
        position
        oriId
      }
      weightMethods {
        id
        name
        position
        oriId
      }
      commodities {
        id
        name
        position
        oriId
      }
      axleGroupTypes {
        id
        name
        position
        oriId
        weightLimit
      }
      stateHighways {
        id
        name
        position
        oriId
        roadType {
          id
          name
          oriId
        }
      }
    }
  }
`;
export const VEHICLE_MAKE_QUERY = gql`
  query VEHICLE_MAKE_QUERY($oriId: ID!) {
    setupLists(oriId: $oriId) {
      vehicleMakes {
        id
        nhtsaId
        name
      }
    }
  }
`;
export const VEHICLE_MODEL_QUERY = gql`
  query VEHICLE_MODEL_QUERY($oriId: ID!) {
    setupLists(oriId: $oriId) {
      vehicleModels {
        id
        nhtsaId
        name
        vehicleMakeId
      }
    }
  }
`;
